import { ApiClient } from 'src/api/axiosClient'
import { IApplicationProcessSchema } from 'src/components/career-landing-page-management/applicationProcess/applicationProcessSchema'
import { IBannerTop } from 'src/components/career-landing-page-management/banner/bannerSchema'
import { IJobSchema } from 'src/components/career-landing-page-management/exploreOurOpportunity/schema'
import { ISeoPageSchema } from 'src/components/career-landing-page-management/seoConfig/seoConfigSchema'
import { IWhyJoinUsSchema } from 'src/components/career-landing-page-management/whyJoinUs/whyJoinUsSchema'
import {
  ECareerBannerType,
  ICareer,
  ICareerBannerData,
  IJobPosting,
  IJobQuery,
  ISeoPage,
} from 'src/interfaces/career-landing-management'

const baseUrl = '/common-contents/'

export const careerLandingManagementAPI = {
  // banner
  createBanner: async (body: IBannerTop) => {
    return await ApiClient.post<{ commonContent: ICareerBannerData }>(
      `${baseUrl}career-banner`,
      body
    )
  },
  getBanner: async (type: ECareerBannerType) => {
    return await ApiClient.get<ICareerBannerData>(
      `${baseUrl}career-banner?type=${type}`
    )
  },

  //why join us
  getWhyJoinUsList: async () => {
    return await ApiClient.get<ICareer[]>(`${baseUrl}career-why-us`)
  },
  createWhyJoinUs: async (params: IWhyJoinUsSchema) => {
    return await ApiClient.post(`${baseUrl}career-why-us`, params)
  },
  updateWhyJoinUsById: async (
    params: Partial<IWhyJoinUsSchema>,
    id: string
  ) => {
    return await ApiClient.put<ICareer[]>(
      `${baseUrl}career-why-us/${id}`,
      params
    )
  },
  deleteWhyJoinUs: async (id: string) => {
    return await ApiClient.delete(`${baseUrl}career-why-us/${id}`)
  },

  // application process
  getApplicationProcessList: async () => {
    return await ApiClient.get<ICareer[]>(
      `${baseUrl}career-application-process`
    )
  },
  createApplicationProcess: async (params: IApplicationProcessSchema) => {
    return await ApiClient.post(`${baseUrl}career-application-process`, params)
  },
  updateApplicationProcessById: async (
    params: Partial<IApplicationProcessSchema>,
    id: string
  ) => {
    return await ApiClient.put<ICareer[]>(
      `${baseUrl}career-application-process/${id}`,
      params
    )
  },
  deleteApplicationProcess: async (id: string) => {
    return await ApiClient.delete(`${baseUrl}career-application-process/${id}`)
  },
  //seo
  getPageSeo: async () => {
    return await ApiClient.get<ISeoPage>(`${baseUrl}seo-career-page`)
  },
  updatePageSeo: async (body: ISeoPageSchema) => {
    return await ApiClient.post<{ commonContent: ISeoPage }>(
      `${baseUrl}seo-career-page`,
      body
    )
  },
  // job opportunity
  getJobList: async ({ page, limit, search, status, sort }: IJobQuery) => {
    return await ApiClient.get<{
      items: IJobPosting[]
      total: number
      page: number
    }>(`job-postings`, {
      params: { page, limit, search, status, sort },
    })
  },
  createJobPosting: async (body: IJobSchema) => {
    return await ApiClient.post(`job-postings`, body)
  },
  updateJobPosting: async (id: string, body: IJobSchema) => {
    return await ApiClient.put(`job-postings/${id}`, body)
  },
  getDetailJobId: async (id: string) => {
    return await ApiClient.get<IJobPosting>(`job-postings/${id}`)
  },

  deleteJobPosting: async (id: string) => {
    return await ApiClient.delete(`job-postings/${id}`)
  },
  toTopJobPosting: async (id: string) => {
    return await ApiClient.put(`job-postings/priority/${id}`)
  },
  upDateStatusPost: async () => {
    return await ApiClient.put(`job-postings/status/expired`)
  },
}
